export default {
  root: {
    backgroundColor: '#f8fafc'
  }
};
